import useSWR from 'swr'
import API from '../../../utils/api'
import { EXCHANGESETTINGS } from '../../constants/APIKEYS'
import { useToken } from '../auth/token'

let KEY = '/admin/exchange'

let swrData: any = null

export function useExchangeAll(detail) {
	KEY = `/admin/exchange?type=${detail ? 1 : 0}`
	const { data: token } = useToken()

	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			const response = await API.get(KEY, '' + token, {}, false)
			swrData = response?.result?.result?.list
			return swrData || []
		},
		{ revalidateOnFocus: true }
	)

	return {
		data,
		mutate: (value: any) => {
			if (value !== undefined) swrData = value
			return mutate()
		},
	}
}
